(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@angular/core"), require("tabby-terminal"), require("tabby-core"));
	else if(typeof define === 'function' && define.amd)
		define(["@angular/core", "tabby-terminal", "tabby-core"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("@angular/core"), require("tabby-terminal"), require("tabby-core")) : factory(root["@angular/core"], root["tabby-terminal"], root["tabby-core"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(global, (__WEBPACK_EXTERNAL_MODULE__860__, __WEBPACK_EXTERNAL_MODULE__349__, __WEBPACK_EXTERNAL_MODULE__650__) => {
return 